import {
  Component,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
  SimpleChanges,
  OnChanges,
  Output,
  EventEmitter, OnDestroy
} from "@angular/core";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { IOsaExecucaoProgramaTrabalhoModel } from '../../../../../models/osa-execucao-programa-trabalho.model';
import { OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoComponent } from "./../osa-execucao-aba-folha-teste-programa-trabalho-questao/osa-execucao-aba-folha-teste-programa-trabalho-questao.component";
import { OsaExecucaoProgramaTrabalhoService } from '../../../../../services/osa-execucao-programa-trabalho.service';
import Swal from "sweetalert2";
import { AuthService } from "../../../../../services/auth.service";
import { OsaExecucaoAbaFolhaTesteProgramaTrabalhoImprimirComponent } from "../osa-execucao-aba-folha-teste-programa-trabalho-imprimir/osa-execucao-aba-folha-teste-programa-trabalho-imprimir.component";
import { SharedService } from "../../../../../services/shared.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { StatusManifestacao } from "../../../../../models/constatacao.model";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-programa-trabalho-lista',
  templateUrl: './osa-execucao-aba-folha-teste-programa-trabalho-lista.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-programa-trabalho-lista.component.scss']
})
export class OsaExecucaoAbaFolhaTesteProgramaTrabalhoListaComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy  {

  constructor(
    private osaExecucaoProgramaTrabalhoService: OsaExecucaoProgramaTrabalhoService,
    private matDialog: MatDialog,
    public router: Router,
    public authService: AuthService,
    private sharedService: SharedService,
    public route: ActivatedRoute) {
  }
  private destroy$ = new Subject<void>();

  public displayedColumns: string[] = [
    'nome',
    'dataHoraFin',
    'nomeResponsavelFin',
    'status',
    'acoes'
  ];

  @Input() listaDados: IOsaExecucaoProgramaTrabalhoModel[] = [] as IOsaExecucaoProgramaTrabalhoModel[];
  @Input() osaExecucaoId!: number;
  @Input() unidadeGestoraId!: number;
  @Input() visualizar: boolean = false;
  @Input() numeroOsa!: string;
  @Output() atualizarProgramaTrabalho = new EventEmitter<void>();
  @Input() planejamentoId: number = 0;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public dataSource: MatTableDataSource<IOsaExecucaoProgramaTrabalhoModel> = new MatTableDataSource();

  ngOnInit(): void {
    this.atualizarLista();

    this.sharedService.statusManifestacao$
      .pipe(takeUntil(this.destroy$))
      .subscribe(status => {
        this.atualizarHabilitacaoPorStatusManifestacao(status);
      });

    //-> Crit 21/23: bloqueia PT/folhas quando Matriz Preliminar Finalizada/Aprovada/Rejeitada (sem F5)
    //-> Rejeitada permanece bloqueada até o botão "Habilitar PT" (que exclui a matriz)
    this.sharedService.statusMatrizPreliminar$
      .pipe(takeUntil(this.destroy$))
      .subscribe((statusMatriz) => {
        this.atualizarHabilitacaoPorStatusManifestacao(
          this.sharedService.getStatusManifestacao(),
          statusMatriz ?? this.sharedService.getStatusMatrizPreliminar());
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private atualizarHabilitacaoPorStatusManifestacao(status: number | null, statusMatrizEmitido?: number | null, somenteBloquear: boolean = false): void {
      //-> Crit 21/23: PT/folhas bloqueados enquanto Matriz Preliminar Finalizada/Aprovada/Rejeitada
      const statusMatriz = statusMatrizEmitido ?? this.sharedService.getStatusMatrizPreliminar();
      const bloqueadoPorMatriz = statusMatriz === 3 || statusMatriz === 4 || statusMatriz === 5;
      const bloqueado = bloqueadoPorMatriz
      || status === StatusManifestacao.Enviado              // 3
      || status === StatusManifestacao.ComSugestoesAcatadas // 4
      || status === StatusManifestacao.ComSugestoesNaoAcatadas // 5
      || status === StatusManifestacao.SemSugestoes;        // 6

    //-> somenteBloquear: override local só pode bloquear (nunca desbloquear sem recarregar do backend)
    if (somenteBloquear && !bloqueado) return;

    if (this.dataSource?.data?.length > 0) {
      this.dataSource.data = this.dataSource.data.map(item => ({
        ...item,
        habilitaAcaoPTMatrizConstatacao: !bloqueado
      }));
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.listaDados || changes.unidadeGestoraId || changes.osaExecucaoId) {
      this.atualizarLista();
    }
  }

  private atualizarLista(): void {
    this.dataSource = new MatTableDataSource(this.listaDados);
    if (this.sort && this.paginator) {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    //-> reaplica o bloqueio da matriz sobre os dados recém-carregados (flag do backend pode estar
    //-> defasada se a matriz foi finalizada após o carregamento); nunca desbloqueia localmente
    this.atualizarHabilitacaoPorStatusManifestacao(this.sharedService.getStatusManifestacao(), undefined, true);
  }

  public routeIncludes(tipoTrabalho: string) {
    return this.router.url.includes(tipoTrabalho);
  }

  public sortingDataAccessor = (item: IOsaExecucaoProgramaTrabalhoModel, property) => {
    switch (property) {
      case "dataHoraFin":
        return item?.dataHoraFin;
      case "nomeResponsavelFin":
        return item?.nomeResponsavelFin;
      case "status":
        return item?.status;
      default:
        return item[property];
    }
  };

  public modalQuestao(titulo: string, visualizar: boolean, element?: IOsaExecucaoProgramaTrabalhoModel) {
    //-> Crit 21/23: bloqueado com Matriz Preliminar Finalizada/Aprovada/Rejeitada
    if (!visualizar && element?.habilitaAcaoPTMatrizConstatacao === false) {
      Swal.fire({
        toast: true, position: "top-end", showConfirmButton: false, timer: 5000,
        timerProgressBar: true, icon: "warning",
        text: "Operação não permitida. Matriz Preliminar Finalizada/Aprovada/Rejeitada — utilize o botão Habilitar PT após rejeição.",
      });
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-programa-trabalho-questao";
    dialogConfig.width = "90vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      visualizar,
      numeroOsa: this.numeroOsa,
      osaExecucaoId: this.osaExecucaoId,
      planejamentoId: this.planejamentoId,
      id: element?.id,
      element
    };
    const modal = this.matDialog.open(
      OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.atualizarProgramaTrabalho.emit();
      }
    });
  }

  public habilitar(element: IOsaExecucaoProgramaTrabalhoModel) {

    Swal.fire({
      title: "Habilitar Programa de Trabalho",
      text: "Deseja habilitar o programa de trabalho?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        const responsavelId = this.authService.usuario.id;
        element.responsavelIdHab = responsavelId;
        element.status = 2;

        this.osaExecucaoProgramaTrabalhoService
          .habilitarProgramaTrabalho(element)
          .then((res) => {
            if (res.sucesso) {

              this.atualizarProgramaTrabalho.emit();

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          }).finally(() => {
          });
      }
    })
  }

  public desabilitar(element: IOsaExecucaoProgramaTrabalhoModel) {

    Swal.fire({
      title: "Desabilitar Programa de Trabalho",
      text: "Deseja desabilitar o programa de trabalho?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        const responsavelId = this.authService.usuario.id;
        element.responsavelIdDesab = responsavelId;
        element.status = 1;

        this.osaExecucaoProgramaTrabalhoService
          .desabilitarProgramaTrabalho(element)
          .then((res) => {
            if (res.sucesso) {

              this.atualizarProgramaTrabalho.emit();

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          }).finally(() => {
          });
      }
    })
  }

  public imprimir(element?: IOsaExecucaoProgramaTrabalhoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-programa-trabalho-imprimir";
    dialogConfig.width = "90vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      numeroOsa: this.numeroOsa,
      id: element?.id,
      element
    };
    const modal = this.matDialog.open(
      OsaExecucaoAbaFolhaTesteProgramaTrabalhoImprimirComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
    });
  }

}
